/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const ResourcesFragment = {
  Resources: gql`
    fragment ResourcesQuery on resources_Entry {
      lineBreak_content
      lineBreak_styles
      resourceCards {
        ... on resourceCardsBlock_Entry {
          resourceBackgroundColor
          resourceCtaLabel
          resourceCtaLink
          resourceCtaLinkNewTab
          resourceCtaLinkNofollow
          resourceCtaTag
          resourceCtaStyle
          resourceImage {
            url
            ... on images_Asset {
              altText
            }
          }
          resourceTextContent {
            html
          }
        }
      }
      resourcesBackgroundImage {
        url
        ... on images_Asset {
          altText
        }
      }
      resourcesTitle
      styles
      typeHandle
    }
  `,
};
